export const formatAmount = (value) => {
  if (value?.toString().indexOf('.') === -1) {
    return value + '.00';
  } else {
    return value;
  }
};